const ColourConstants = {
	// delete dialog hover color
	deleteDialogHover: "#d5d5d5",
	activeLink: "#307AD7",
	deleteLink: "#E21313",

	requiredStar: "#E21313",

	commonText: "#393939",
	commonBorder: "#404149",
	commonNoteText: "#545353",

	confirmButton: "#23BB79",
	cancelButton: "#E21313",
	deleteButton: "#E21313",
	deleteCancelButton: "#23BB79",
	duplicateButton: "#EE8737",

	yesText: "#23BB79",
	integrationInstanceBorder: "#cccccc",
	tableBorder: "#979797",
	tableBackground: "#D2D2D9",
	tableBackgroundSelected: "#979797",

	navDrawer: "#EFA934",
	navCurrentItem: "#D98D24",

	navButtonOnHover: "#404149",
	navButtonTextColor: "#000000",
	uploaderBorder: "",
	uploaderIcon: "#307AD7",

	deleteIcon: "#E21313",

	divider: "#C5C5C8",
	dropdownheaderBorder: "#c1c1c1",
	red: "#E31212",
	orange: "#ED8738",
	green: "#23BB79",
	tableRowExpand: "#307AD7",
	tableRowNormal: "#FFFFFF",
	//for task  table - load more
	hoverGrey: "#eeeeee",
};

export default ColourConstants;
